import * as React from 'react';
import CapturePaymentData from '../components/CapturePaymentData';
import PaymentDetails from '../components/PaymentDetails';
import { Card, Box, Typography, Grid } from '@mui/material';
import { useAppContext, usePaymentContext } from '../context';

export default function PaymentPage() {
    const appContext = useAppContext();
    const paymentContext = usePaymentContext();

    React.useEffect(() => {
        if (!paymentContext.transactionUrl)
            appContext.navigateToLandingPage();
    }, [paymentContext.transactionUrl]);

    return (
        <>
            <Box textAlign="left">
                <Typography variant="h2" gutterBottom>{paymentContext.paymentRequest?.description}</Typography>
                <Typography variant="h6" gutterBottom>To allow us to continue with your claim, you will need to make a payment of {paymentContext.paymentRequest?.paymentValueAsString}</Typography>
            </Box>

            <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 9 }}>
                    <Card>
                        <Box minHeight={540}>
                            <Box width={1}>
                                <CapturePaymentData />
                            </Box>
                        </Box>
                    </Card>
                </Grid>
                <Grid size={{ xs: 12, md: 3 }}>
                    <Box display={{ xs: 'none', sm: 'none', md: 'block' }}>
                        <Card>
                            <Box p={2} minHeight={540}>
                                <PaymentDetails />
                            </Box>
                        </Card>
                    </Box>
                </Grid>
            </Grid>
        </>
    )
}
